export default __webpack_public_path__ + "static/media/bg-3.eb8927a6.jpg";